import React from "react";

export default  function NotFound (){
    return(
        <main id={'not_found'}>
            <h1>Страница не найдена</h1>
        </main>
    )
}
